import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  unit: yup.string().required('Selecione uma unidade')
})
